import React from 'react'
import {AuthContext} from '../../../lib/AuthContext';
import ParentComponent from '../../../lib/ParentComponent';
import firebase, {auth} from '../../../lib/firebase';
import Utils from '../../../Utils';
import FieldLayout from '../../../lib/FieldLayout';
import ar from '../../../locale';

export default class ClubFormations extends ParentComponent {
    
    static contextType = AuthContext;
    
    constructor(props, context) {
        super(props, context);
        this.state = {
            user: context.user,
            loading: false,
            token: null,
            deleting: {},
            formations: [],
        }
        this.formationPath = 'clubs_formations/' + this.props.club.key + '/';
        this.formationsRef = firebase.database().ref(this.formationPath);
        this.commentRef = firebase.database().ref('comments/' + this.formationPath);
    }

    componentDidMount() {
        super.componentDidMount();
        auth.currentUser.getIdToken().then(token => {
            this.state.token = token;
            this.updateState();
        });
        this.formationsRef.orderByChild('featured').on('value', response => {
            this.state.formations = Utils.convertToArrayWithOrderKeyDesc(response.val(), 'featured');
            this.updateState();
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.formationsRef.off('value');
    }

    showLoading = show => {
        this.state.loading = show;
        this.updateState();
    };

    updateState = () => {
        this.setState(prev => {
            return {...prev}
        })
    };

    deleteConfirmation = (formation) => {
        this.confirm(null,this.deleteFormation.bind(this,formation));
    };

    deleteFormation = (formation) => {
        this.state.deleting[formation.key] = true;
        this.updateState();
        this.deleteFormationPromise(formation)
        .then(() => this.deleteFormationCommentPromise(formation))
        .then(() => {
            this.updateState();
        })
        .catch(error => {
           this.state.deleting[formation.key] = false;
           this.showError(error.message); 
           this.updateState();
        });
    };

    deleteFormationPromise = (formation) => {
        return this.formationsRef.child(formation.key).remove();
    };

    deleteFormationCommentPromise = (formation) => {
        return this.commentRef.child(formation.key).remove();
    }

    onMarkFeatured = (formation , e) => {
        return this.formationsRef.child(formation.key).update({
            featured: e.target.checked,
        }).then(()=> {
            this.showSuccess(ar.operation_successful);
        }).catch(error => {
           this.showError(error.message); 
           this.updateState();
        });
    };

    renderFormation = formation => {
        return(
            <FieldLayout key={formation.key} 
                onDelete={this.deleteConfirmation.bind(this,formation)}
                formation={formation}
                club={this.props.club}
                onFeatured={this.onMarkFeatured.bind(this,formation)}
                deleting={this.state.deleting[formation.key]}
            />
        );
    }

    render() {
        return(
            <div className="w-100 d-flex flex-wrap">
                {this.state.formations.map((formation,index) => this.renderFormation(formation,index))}
            </div>
        );
    }
}